import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_REFFERALS_DATA, FETCH_REFFERALS_EDIT_DATA } from "./actionTypes";
import {
  fetchRefferalsSuccess,
  fetchRefferalsFailure,
  fetchRefferalsEditSuccess,
  fetchRefferalsEditFailure,
} from "./actions";

function* fetchRefferalsDataSaga() {
  try {
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + "/api/web/refferals",{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchRefferalsSuccess(response.data));
  } catch (error) {
    yield put(fetchRefferalsFailure(error.message));
  }
}

function* fetchRefferalsEditDataSaga(action) {
  try {
    const id = action.payload;
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + `/api/web/refferals/${id}`,{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchRefferalsEditSuccess(response.data));
  } catch (error) {
    yield put(fetchRefferalsEditFailure(error.message));
  }
}

export default function* refferalsSaga() {
  yield takeEvery(FETCH_REFFERALS_DATA, fetchRefferalsDataSaga);
  yield takeEvery(FETCH_REFFERALS_EDIT_DATA, fetchRefferalsEditDataSaga);
}
